module.exports = __webpack_public_path__ + "static/media/skill-seo-hero-1.55ece7db.jpg";